<template>
  <div id="app">
  	<div :class="menuFixed?'header-fixed header-box':'header-box'">
  		<HeaderPart  @backHeaderHeight="backHeaderHeight"></HeaderPart>
  	</div>
  	<div :class="menuFixed?'add-top page-concent':'page-concent'" :style="{ 'min-height': pageHeight + 'px' }">
  		<router-view/>
  	</div>
    <FooterPart @backFootHeight="backFootHeight"></FooterPart>
  </div>
</template>

<script>
	import HeaderPart from '@/components/PublicMould/Header'
	import FooterPart from '@/components/PublicMould/Footer'
	export default {
		name: 'App',
		watch:{
			'headHeight':'dealPageHeight',
			'footHeight':'dealPageHeight'
		},
		data() {
			return {
				menuFixed:false,
				headHeight:null,
				footHeight:null,
				pageHeight:null,
			}
		},
		mounted() {
		},
		created() {
			this.init();
		},
		mounted(){
			window.addEventListener('scroll', this.scrollFun);
		},
		//销魂监听滚动事件
		destroyed(){
		    window.removeEventListener('scroll',this.scrollFun,false)
		},
		methods: {
			init:function(){
			},
			scrollFun:function(){
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
//				console.log(scrollTop);
				
				if(scrollTop>1){
					this.menuFixed=true;
				}else{
					this.menuFixed=false;
				}
			},
			backFootHeight:function(val){
				this.headHeight=val;
			},
			backHeaderHeight:function(val){
				this.footHeight=val;
			},
			dealPageHeight:function(){
				var that=this;
				
				if(this.headHeight && this.footHeight){
					that.$nextTick(function(){
						that.pageHeight = document.documentElement.clientHeight - that.footHeight - that.headHeight;
					});
				}
			}
		},
		components: {
			HeaderPart,
			FooterPart,
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue